<template>
  <div ref="scrollContainer" id="page-panel" class="box grow scrollable only-y" >
    <resize-observer @notify="__resizeHanlder" />
    <div class="customer-top-nav no-print">
      <div class="title">
        <span>{{$t('left-menu.reports')}}</span>
      </div>
    </div>
    <el-row  :gutter="20" v-for="(c, index) in reportByCategory" :key="index">
      <h4 v-if="c!=null">{{$t('reports.categories.'+c.type)}}</h4>
      <div v-if="c!=null">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="4" v-for="r in c.reports" :key="r.id">
          <reportTile  :disabled="r.disabled" :title="r.title" :description="r.description" :code="r.code"></reportTile>
        </el-col>
      </div>
    </el-row>
  </div>
</template>
<script>
//import Section
import reportTile from './components/report-tile.vue'
import axios from 'axios'
import { mapGetters } from 'vuex';
export default {
  name : "reports",
  data() {
    return {
      reports : [],
      loading:false,
    };
  },
  components : {
    reportTile
  },
  computed : {
    reportByCategory(){
      let reports = [];
      let category = null;
      _.forEach(this.reports, r=>{
        let canShow = true;
        if (r.code === 'WINE_SALES_REP') {
          if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && !this.isCurrentUserAdmin) {
            canShow = false;
          }
        }
        if(this.$can('read', r.resource) && r.resource !== 'CUSTOM_EXTERNAL_REPORT' && canShow){
          if(category==null || (category!=null && category.type!=r.type)){
            if(category!=null)reports.push(category);
            category = {type:r.type, reports:[]}
          }
          category.reports.push(r);
        }


      })
      reports.push(category);
      return reports;
    },
     ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'isCurrentUserAdmin']),
  },
  methods : {
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchReportsDefinition(){
      this.loading = true;
      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/reports")
        .then(response=>{
          this.reports = response.data;
          this.loading = false;
        })
    }
  },
  created(){
    return this.fetchReportsDefinition();

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
